import React from 'react';

const CameraFrame = ({ children, className = '', active = false }) => {
  return (
    <div className={`camera-frame bg-[#121212] border border-[#2a2a2a] ${active ? 'border-pink-500/50 shadow-[0_0_15px_rgba(236,72,153,0.15)]' : ''} ${className}`}>
      <div className="camera-frame-inner h-full w-full">
        {children}
      </div>
    </div>
  );
};

export default CameraFrame;